document.addEventListener('turbolinks:load', function() {
  if ( $('#sales-index-wrapper').length > 0 ) {

    let inputTimer;

    /**
     * モーダル定義
     * self.showModal() で表示
     * self.close() で閉じる
     */
    const detailModal = document.getElementById('detail-modal');
    const loadingModal = document.getElementById('loading-modal');
    const importModal = document.getElementById('import-modal');
    const mailHelperModal = document.getElementById('mail-helper-modal');

    // 編集可能な要素にdata-idを自動セット
    $('.sales-info [data-name]').attr('data-id', function() {
      return $(this).closest('.sales-info').attr('data-id');
    });

    // モーダルの表示イベント設定
    $('.sales-info').on('click', function() {
      // .open-modalクラスを持つ要素のクリックのみを対象とする
      if ( ! $(event.target).is('.open-modal') ) {
        return;
      }
      $('.sales-info.selected').removeClass('selected');
      $(this).addClass('selected');
      getDetail( $(this) );
      getContactHistories( $(this).attr('data-id') );
      // detailModalをeditモードにする
      detailModal.setAttribute('data-mode', 'edit');
      if (detailModal.showModal) {
        detailModal.showModal();
        $("#contact-history-memo").focus();
      }
    });

    // エスケープキーでモーダルを閉じないようにする
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
      }
    });


    /**
     * 詳細モーダルのデータ読み込み
     */
    function getDetail( caller ) {
      setTimeout(function() { loadingModal.showModal(); }, 0);
      $.ajax({
        url: '/sales/get_detail',
        type: 'POST',
        data: {
          id: caller.attr('data-id')
        }
      })
        .then(function(data) {
          if (data['ret'] === 0) {
            // data['object']内のキーと一致するdata-nameを持つ要素に値をセット. 更新用にdata-idを自動セット
            for (let key in data['object']) {
              let elm = $(`#detail-modal [data-name="${key}"]`);
              // 対象要素がない場合はスキップ
              if (elm.length === 0) {
                continue;
              }
              elm.attr('data-id', data['object']['id']);
              attachValue(elm, key, data['object'][key]);
              $('#create-tel-history').data('id', data['object']['id']); // テレアポ記録ボタンにidをセット
            }
          } else {
            alert(data['message']);
          }
        })
        .fail(function() {
          alert('詳細の取得に失敗しました');
        })
        .always(function() {
          loadingModal.close();
        })
    }


    /**
     * セレクト、チェックボックスの値を変更したら自動保存
     * @param {jQuery Object} caller イベント発火元の要素
     * @return {void}
     */
    function updateData(caller) {
      let url = '/sales/update_data';
      // id取得
      let id = caller.attr('data-id');
      if (id === undefined) {
        return;
      }
      let data = {
        id: id,
        key: caller.data('name'),
        value: ""
      };
      // 対象要素がチェックボックスの場合は値の取得方法を変更
      if (caller.is('input[type="checkbox"]') && caller.prop('checked')) {
        // チェックが入った場合は1をセット
        data['value'] = 1;
      } else if (caller.is('input[type="checkbox"]') && !caller.prop('checked')) {
        // チェックが外れた場合は0をセット
        data['value'] = 0;

      } else {
        // それ以外はval()で取得
        try {
          data['value'] = caller.val();
        } catch (e) {
          return;
        }
      }
      // POST
      $.ajax({
        url: url,
        type: 'POST',
        data: data
      })
        .then(function(result) {
          if (result['ret'] === 0) {
            // 成功時は表示を更新
            let target = $(`[data-name="${data['key']}"][data-id="${data['id']}"]`);
            if (target.length > 0) {
              // 要素一覧をチェックし、フォーカスされてる場合はtargetから除外
              target.each(function( i, e) {
                if ( $(e).is(':focus') ) {
                  target.splice(i, 1);
                }
              });
              attachValue(target, data['key'], data['value']);
            }
          }
          if (result['ret'] !== 0) {
            // 失敗時はアラートを表示
            alert(result['message']);
          }
        })
        .fail(function() {
          alert('更新に失敗しました');
        })
    }

    /**
     * 更新イベントの対象は、editableクラスを持つ要素
     */
    // セレクトボックスの変更イベント
    $('select.editable').on('change', function() {
      updateData( $(this) );
    });
    // チェックボックスの変更イベント
    $('input[type="checkbox"].editable').on('change', function() {
      updateData( $(this) );
    });
    // 日付系の変更イベント
    $('input[type="date"].editable').on('change', function() {
      updateData( $(this) );
    });
    // テキストボックスの変更イベント. キーアップの0.5秒後に自動保存. 連続で入力された場合は最後の入力が保存される
    $('input[type="text"].editable, textarea.editable').on('input', function() {
      let caller = $(this);
      clearTimeout(inputTimer);
      inputTimer = setTimeout(function() {
        updateData( caller );
      }, 500);
    });

    /**
     * 手紙管理の変更イベント
     * - 手紙対象がONになった場合は、手紙関連のフラグと投函日のdisabledを解除
     * - 手紙対象がOFFになった場合は、手紙関連のフラグと投函日をdisabledにする
     */
    $('[data-name="is_letter_target"]').on('change', function() {
      let id = $(this).attr('data-id');
      let bool = $(this).prop('checked');
      $('[data-name="is_letter_body_wrote"][data-id="'+id+'"]').prop('disabled', !bool);
      $('[data-name="is_letter_address_wrote"][data-id="'+id+'"]').prop('disabled', !bool);
      $('[data-name="is_letter_posted"][data-id="'+id+'"]').prop('disabled', !bool);
      $('[data-name="letter_posted_at"][data-id="'+id+'"]').prop('disabled', !bool);
    });

    /**
     * 投函ステータス変更時の補助イベント
     * 投函済みをチェックした場合は投函日を自動入力。本文、宛名を自動ONにする
     * 投函済みのチェックを外した場合は投函日を空にする
     */
    $('.editable[data-name="is_letter_posted"]').on('change', function() {
      let id = $(this).attr('data-id');
      let isLetterBodyWrote = $('[data-name="is_letter_body_wrote"][data-id="'+id+'"]');
      let isLetterAddressWrote = $('[data-name="is_letter_address_wrote"][data-id="'+id+'"]');
      let letterPostedAt = $('[data-name="letter_posted_at"][data-id="'+id+'"]');
      if ( $(this).prop('checked') ) {
        isLetterBodyWrote.prop('checked', true);
        isLetterAddressWrote.prop('checked', true);
        letterPostedAt.val(new Date().toISOString().split('T')[0]);
      } else {
        let id = $(this).attr('data-id');
        let letterPostedAt = $('[data-name="letter_posted_at"][data-id="'+id+'"]');
        letterPostedAt.val('');
      }
      updateData( $(this) );
      updateData( isLetterBodyWrote );
      updateData( isLetterAddressWrote );
      updateData( letterPostedAt );
    });


    /**
     * 値を要素にセットする際のルール設定
     * - checkbox: 1ならチェック, 0なら非チェック
     * - select: valueにセット
     * - input: valueにセット
     * - a: hrefとtextにセット
     * - その他: textにセット
     * @param {jQuery Object} element 対象要素
     * @param {string} key キー
     * @param value 値
     */
    function attachValue( element, key, value ) {
      if ( element.is('input[type="checkbox"]') ) {
        if (value === 1) {
          element.prop('checked', true);
        } else {
          element.prop('checked', false);
        }
      } else if ( element.is('input[type="date"]') ) {
        // Tでsplitして最初のブロックを取得
        if (value === null) {
          element.val('');
        } else {
          element.val(value.split('T')[0]);
        }
      }else if ( element.is('select') ) {
        // selectの場合はvalueにセット
        element.val(value);
        // 業種カテゴリの場合は、カテゴリ名をセットしてバッジ表示
        if (key === 'sales_category_id') {
          let id = element.attr('data-id');
          let categoryName = $(`select[data-name="sales_category_id"] option[value="${value}"]`).first().text();
          $(`div[data-name="sales_category_id"][data-id="${id}"]`).text(categoryName);
        }

      } else if ( element.is('input') || element.is('textarea') ) {
        // inputかtextareaの場合はvalueにセット
        element.val(value);
        // URL系の場合は、data-hrefにもセット
        if (key === 'url' || key === 'instagram_url') {
          element.attr('data-href', value);
          return;
        }
        try {
          //detailModalではinputでも、テーブル上はテキストの場合があるので、エラーハンドルを設置してTEXT書き込みを試行。
          let prefix = '';
          let suffix = '';
          // 担当者名には「様」を付与
          if ( key === 'manager_name' ) {
            suffix = ' 様';
          }
          element.text(prefix + value + suffix);
        }catch (e) {
          //
        }

      } else if ( element.is('a') ) {
        // aタグの場合はhrefとtextにセット
        element.attr('href', value);
        element.text(value);

      } else {
        // それ以外はtextにセット.
        element.text(value);
      }
    }


    // ##### 連絡履歴 #####
    /**
     * 連絡履歴の作成
     */
    $('#create-history').on('click', function() {
      let id = $('.sales-info.selected').attr('data-id');
      let caller = $(this);
      let memo = $('#contact-history-memo').val();
      if (memo.trim() === '') {
        alert('内容は必須です');
        return;
      }
      $.ajax({
        url: '/sales/create_contact_history',
        type: 'POST',
        data: {
          id: id,
          contact_type: $('#contact-type').val(),
          memo: memo
        }
      })
        .then(function(data) {
          if (data['ret'] === 0) {
            alert('連絡履歴を作成しました');
            $('#contact-history-memo').val('');
            getContactHistories(id);
          } else {
            alert(data['message']);
          }
        })
        .fail(function() {
          alert('連絡履歴の作成に失敗しました');
        })
    });

    /**
     * 連絡履歴の取得
     */
    function getContactHistories(customer_id) {
      $.ajax({
        url: '/sales/get_contact_histories',
        type: 'POST',
        data: {
          id: customer_id
        }
      })
        .then(function (data) {
          if (data['ret'] === 0) {
            $('#contact-histories').empty();
            if (data['object'].length === 0) {
              $('#contact-histories').append('<div class="history">連絡履歴がありません</div>');
            }else{
              data['object'].forEach(function (history) {
                let html = `
                <div class="history">
                  <div class="date">${history['contacted_at']}</div>
                  <div class="type">${history['contact_type']} ( ${history['sales_user_name']} ) </div>
                  <div>---</div>
                  <div class="memo">${history['memo']}</div>
                </div>
              `;
                $('#contact-histories').append(html);
              });
            }
          }
        })
        .fail(function() {
          alert('連絡履歴の取得に失敗しました');
        })
    }


    /**
     * CSVインポートイベント
     */
    // インポート用モーダル表示
    $('#import-csv').on('click', function() {
      importModal.showModal();
    });
    // インポート実行
    $('#start-import-csv').on('click', function() {
      let file = $('#csv-file').prop('files')[0];
      if (file === undefined) {
        alert('ファイルを選択してください');
        return;
      }
      setTimeout(function() { loadingModal.showModal(); }, 0);
      let formData = new FormData();
      formData.append('csv', file);
      $.ajax({
        url: '/sales/import_csv',
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false
      })
        .then(function(data) {
          if (data['ret'] === 0 && data['existing_list']) {
            let message = '以下の顧客は既に登録されているため、インポートされませんでした。\n';
            data['existing_list'].forEach(function(customer) {
              message += `${customer}\n`;
            });
            alert(message);
            location.reload();
          } else if ( data['ret'] === 0 ) {
            alert('全てのインポートが完了しました');
            location.reload();
          } else {
            alert(data['message']);
          }
        })
        .fail(function() {
          alert('インポートに失敗しました');
        })
        .always(function() {
          loadingModal.close();
        })
    });


    /**
     * 検索
     */
    $('#start-search').on('click', function() {
      redirectWithQueries();
    });

    /**
     * 条件をクリアイベント
     */
    $('#clear-filter').on('click', function() {
      $('#filters [data-name]').each(function() {
        if ($(this).is('input[type="checkbox"]')) {
          $(this).prop('checked', false);
        } else {
          $(this).val('');
        }
      });
    });

    /**
     * アクセス時に、クエリに対応する要素に値をセット
     */
    let searchQueries = new URLSearchParams(location.search);
    if (searchQueries.size > 0) {
      searchQueries.forEach(function(value, key) {
        // sales_contact_status_idはURL上では+で区切られているが、実際にはスペース区切りで取得されるため、スペースでsplitして値をセット
        if (key === 'sales_contact_status_id') {
          let statusIds = value.split(' ');
          statusIds.forEach(function(statusId) {
            $(`[data-name="sales_contact_status_id"][data-status-id="${statusId}"]`).prop('checked', true);
          });
          return;
        }
        // それ以外
        let target = $(`[data-name="${key}"]`);
        if (target.is('input[type="checkbox"]')) {
          if (value === '1') {
            target.prop('checked', true);
          }
        } else {
          target.val(value);
        }
      });
      // URLにクエリがある場合に、アコーディオンを開いておく場合はコメントアウトを外す
      // $('[name="filter-accordion"]').prop('checked', true);
    }

    /**
     * 新規作成に関するイベント
     */
    // 新規モードでdetailModalを開く
    $('#new-customer').on('click', function() {
      // 初期値をクリア
      $('#detail-modal input, #detail-modal textarea').val('');
      $('#detail-modal input[type="checkbox"]').prop('checked', false);
      $('#detail-modal select').val('');
      $('#detail-modal [data-id]').removeAttr('data-id');
      // 新規モードに設定
      detailModal.setAttribute('data-mode', 'new');
      detailModal.showModal();
    });

    // 新規作成ボタン
    $("#create-customer").on("click", function() {
      let name = $('#detail-modal [data-name="name"]').val();
      if (name.trim() === '') {
        alert('会社名は必須です');
        return;
      }
      let data = {};
      $('#detail-modal input, #detail-modal textarea, #detail-modal select').each(function() {
        if ($(this).is('input[type="checkbox"]')) {
          // チェックボックスがチェックされている場合は1とする
          if ($(this).prop('checked')) {
            data[$(this).data('name')] = 1;
          } else {
            data[$(this).data('name')] = 0;
          }
        }else{
          data[$(this).data('name')] = $(this).val();
        }
      });
      setTimeout(function() { loadingModal.showModal(); }, 0);
      $.ajax({
        url: '/sales/create_customer',
        type: 'POST',
        data: data
      })
        .then(function(data) {
          if (data['ret'] === 0) {
            alert('新規顧客を作成しました');
            location.reload();
          } else {
            alert(data['message']);
          }
        })
        .fail(function() {
          alert('新規顧客の作成に失敗しました');
        })
        .always(function() {
          loadingModal.close();
        })
    })


    /**
     * URLへのリンクイベント
     * .sales-info内のdata-name="url", "instagram_url"を持つ要素をクリックしたときに、data-hrefにセットされたURLに遷移
     * data-hrefがない場合は何もしない
     * ページは新規タブで開く
     */
    $('.sales-info').on('click', '[data-name="url"], [data-name="instagram_url"]', function() {
      let url = $(this).attr('data-href');
      if (url === undefined || url.trim() === '') {
        return;
      }
      window.open(url, '_blank');
    });


    /**
     * ソートオプションの選択イベント
     * 選択したoptionの data-sort-name と data-sort-direction を取得して、ソートを実行
     */
    $('#apply-sort').on('click', function() {
      redirectWithQueries();
    });


    /**
     * クエリ結合を行い、リダイレクトするための関数
     * - 検索状件のチェック
     * - ソート条件のチェック
     */
    function redirectWithQueries() {
      let queries = [];
      let contactStatuses = "";
      // 検索状件のチェック
      // #filters内のdata-nameを持つ要素の値を取得してクエリに追加
      $('#filters [data-name]').each(function() {
        // ステータスはチェックボックスで複数をOR検索できるように、スペース区切りで格納
        if ($(this).is('[data-name="sales_contact_status_id"]') && $(this).prop('checked') ) {
          contactStatuses += $(this).attr('data-status-id') + " ";
          return;
        }
        // それ以外
        if ($(this).is('input[type="checkbox"]')) {
          if ($(this).prop('checked')) {
            queries.push({ name: $(this).data('name'), value: 1 });
          }
        } else if ( $(this).val() !== "" ) {
          queries.push({ name: $(this).data('name'), value: $(this).val() });
        }
      });
      // 連絡ステータスのクエリを格納
      if (contactStatuses !== "") {
        queries.push({ name: 'sales_contact_status_id', value: contactStatuses.slice(0, -1) });
      }

      // ソート条件のチェック
      let selectOption = $('#sort-options option:selected');
      let sortName = selectOption.data('sort-name');
      let sortDirection = selectOption.data('sort-direction');
      // クエリにソート条件を追加
      queries.push({ name: 'sort_name', value: sortName });
      queries.push({ name: 'sort_direction', value: sortDirection });

      let url = new URL(location.href);
      // 既存のクエリは削除
      url.search = '';
      // クエリを結合してリダイレクト
      queries.forEach(function (query) {
        url.searchParams.set(query.name, query.value);
      });
      location.href = url.href;
    }




  } // end
});
